import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  Tag,
  Form,
  Result,
  Button,
  Table,
  Drawer,
  Skeleton,
} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import ErrorPage from "../pages/ErrorPage";
import ForbiddenPage from "../pages/ForbiddenPage";
import FieldComponent from "./FieldComponent";
import EditFormComponent from "./EditFormComponent";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {useAxios} from "../hooks/hooks";
import {cancelTokenSource} from "../hooks/hooks";

function ViewFormComponent(props) {
  const axios = useAxios();
  const source = cancelTokenSource;
  const { t } = useTranslation();
  const [forbidden, setForbidden] = useState(false);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [row, setRow] = useState({});
  const [display, setDisplay] = useState([]);
  const [drawerVisibility, setDrawerVisibility] = useState(false);
  const [columns] = useState([
    {
      title: t("Property"),
      dataIndex: "k",
      key: "k",
    },
    {
      title: t("Value"),
      dataIndex: "v",
      key: "v",
      render: (text, record) => (
        <FieldComponent view={true} fieldtype={record.fieldtype} value={text} />
      ),
    },
  ]);
  const layout = {
    layout: "vertical",
    labelCol: { span: 16 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 20,
      span: 4,
    },
    style: {
      marginBottom: "0px",
    },
  };
  const onBack = () => {
    props.history.goBack();
  };

  const onFinish = (values) => {
    console.log("here")
    var url = props.endpoint.namespace.code + "/" + props.id.toString().replace("#", "").split(" ")[0];
    console.log(url)
    if (props.endpoint.entity.is_meta === true) {
      url += "?_rev=" + row._rev;
    }
    console.log(url)
    axios.current.delete(url)
      .then(function (response) {
        var result = response.data;
        if (result.error) {
          setError(JSON.stringify([result.error]));
          return;
        }
        setDeleted(true);
        if (props.onDelete) {
          try {
            props.onDelete(props.id, true);
          } catch (e) {}
        }
      })
      .catch(function (error) {
        setError(JSON.stringify([error]));
        if (props.onDelete) {
          try {
            props.onDelete(props.id, false);
          } catch (e) {}
        }
      })
      .then(function () {
        setLoaded(true);
      });
  };

  useEffect(()=> {
  }, [loaded])

  useEffect( () => {
    console.log(props)
    axios.current.get(props.endpoint.namespace.code + "/" + props.id.toString().replace("#", "").split(" ")[0])
        .then(function (response) {
          var result = response.data;
          if (result.error) {
            setError(result.error.error);
            return;
          }
          if (result.length === 0) return;
          var datasource = [];
          var row = result[0];
          setRow(row);
          var index = 1;
          setDisplay(row.DISPLAY_FIELD);
          delete row.ID;
          delete row.DISPLAY_FIELD;
          var attributes = JSON.parse(JSON.stringify(props.endpoint.attributes));
          for (var g in props.endpoint.groups) {
            const group = props.endpoint.groups[g];
            var group_row = {
              key: "_group_" + g,
              k: group.name,
              v: {},
              fieldtype: group.fieldtype.name,
            };
            for (var k in group.properties) {
              var p = group.properties[k];
              var foreign_key =
                  props.endpoint.entity.is_meta === true
                      ? null
                      : attributes[p].mysql.foreign_key;
              var field = p;
              var type = attributes[p].fieldtype.name;
              if (foreign_key) {
                field = attributes[p].foreign_display_alias;
                type = "foreign_key";
              }
              group_row.v[k] = row[field];
              delete attributes[p];
            }
            datasource.push(group_row);
          }
          for (k in attributes) {
            foreign_key =
                props.endpoint.entity.is_meta === true
                    ? null
                    : attributes[k].mysql.foreign_key;
            field = k;
            type = props.endpoint.attributes[k].fieldtype.name;
            if (foreign_key) {
              field = props.endpoint.attributes[k].foreign_display_alias;
              type = "foreign_key";
            }
            datasource.push({
              key: index,
              k: t(props.endpoint.attributes[k].name),
              v: row[field],
              fieldtype: type,
            });
            ++index;
          }
          setDatasource(datasource);
          setLoaded(true);
        })
        .catch(function (error) {
          // if (axios.current.isCancel(error) === true) return;
          if (error.response) {
            switch (error.response.status) {
              case 401:
                setForbidden(true);
                break;
              default:
                setError(JSON.stringify(error));
            }
          }
          setLoaded(true);
        });
  }, [props.id, props.endpoint]);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  if (!loaded) {
    return <Skeleton active />;
  }
  if (loaded && forbidden) {
    return <ForbiddenPage />;
  }
  if (loaded && error) {
    return <ErrorPage error={error} />;
  }
  if (loaded && deleted) {
      <Result
        status="success"
        title={t("Done")}
        subTitle={t("Entity #id has been deleted successfully.", {
          entity: props.endpoint.entity.name,
          id: props.id,
        })}
        extra={[
          <Button key="1">
            <Link
              replace={true}
              to={props.home + props.endpoint.namespace.code}
            >
              {t("Back to Entity", { entity: props.endpoint.namespace.name })}
            </Link>
          </Button>,
        ]}
      />
    ;
  }
  if (loaded && !error && !deleted) {
    return (
      <>
        {props.remove !== true && (
          <PageHeader
            style={{ padding: "0px 0px 16px 0px" }}
            title={display}
            tags={
              <>
                <Tag color="blue">{t(props.endpoint.namespace.name)}</Tag>
                <Tag color="geekblue">ID:{props.id}</Tag>
              </>
            }
            onBack={props.back === false ? false : onBack}
            extra={
              props.update
                ? props.endpoints
                  ? [
                      <Button
                        key="1"
                        block
                        onClick={() => {
                          setDrawerVisibility(true);
                        }}
                      >
                        <FontAwesomeIcon icon="edit" />
                        &nbsp;{t("Edit")}
                      </Button>,
                    ]
                  : [
                      <Button key="1" block>
                        <Link
                          replace={true}
                          to={
                            props.home +
                            props.endpoint.namespace.code +
                            "/edit/" +
                            props.id.toString().replace("#", "").split(" ")[0]
                          }
                        >
                          <FontAwesomeIcon icon="edit" />
                          &nbsp;{t("Edit")}
                        </Link>
                      </Button>,
                    ]
                : []
            }
          />
        )}
        {props.remove === true && (
          <PageHeader
            style={{ padding: "0px 0px 16px 0px" }}
            title={display}
            onBack={props.back === false ? false : onBack}
            tags={
              <>
                <Tag color="blue">{props.endpoint.namespace.name}</Tag>
                <Tag color="red">ID:{props.id}</Tag>
              </>
            }
          />
        )}
        <Table
          scroll={{ x: "100%" }}
          columns={columns}
          dataSource={datasource}
          pagination={false}
          footer={() =>
            props.remove === true && (
              <Form {...layout} name="delete-form" onFinish={onFinish}>
                <Form.Item {...tailLayout}>
                  <Button block type="primary" htmlType="submit" danger>
                    <FontAwesomeIcon icon="trash" />
                    &nbsp;
                    {t("Delete")}
                  </Button>
                </Form.Item>
              </Form>
            )
          }
        />
        <Drawer
          title={t("Edit Record")}
          open={drawerVisibility}
          onClose={() => {
            setDrawerVisibility(false);
          }}
          placement="left"
          width="75%"
        >
          {props.endpoints && (
            <EditFormComponent
              home="/dashboard/"
              endpoints={props.endpoints}
              endpoint={props.endpoints[props.endpoint.namespace.code].create}
              remove={
                props.endpoints[props.endpoint.namespace.code].remove
                  ? true
                  : false
              }
              id={props.id}
              history={props.history}
              back={false}
            />
          )}
        </Drawer>
      </>
    );
  }
}

export default ViewFormComponent;
